<template>
  <div class="page"  style="padding: 16px">
    <div style="">
      <img style="width: 60px" src="./assets/zztj.png">
      <div style="font-size: 36px;font-weight: bolder;color: red">五分钟教你打赢仲裁</div>
    </div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="离职补偿金" name="first"><about-view/></el-tab-pane>
      <el-tab-pane label="失业保险金" name="second"><benefits-view/></el-tab-pane>
<!--      <el-tab-pane label="Role" name="third">Role</el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue';
import type { TabsPaneContext } from 'element-plus'
import AboutView from "@/views/AboutView.vue";
import { ref } from 'vue'
import BenefitsView from "@/views/BenefitsView.vue";
const activeName = ref('first')

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event)
}
</script>

<style>

.page {
  background-color: #f5f5f5;
  min-height: 95vh; /* 设置最小高度为视口高度，确保背景覆盖整个视口 */
  //min-height: 100vh; /* 设置最小高度为视口高度，确保背景覆盖整个视口 */
  box-sizing: border-box; /* 确保padding不影响元素的总高度 */
}
.demo-tabs > .el-tabs__content {
  //padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
</style>
